import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Business, BusinessSearch } from '../../models/finance/business';
import { map, Observable } from 'rxjs';
import { ApiResponse, PaginatedApiResponse } from '@card-software/library';

@Injectable({
  providedIn: 'root',
})
export class FinanceProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.financeApi + '/api/v1/business';

  getAllProviders(businessSearch: BusinessSearch): Observable<ApiResponse<Business[]>> {
    const params = new HttpParams().append('matchAny', true);

    return this.httpClient
      .post<ApiResponse<PaginatedApiResponse<Business>>>(`${this.baseUrl}/search`, businessSearch, { params })
      .pipe(map((res) => ({ ...res, data: res.data?.items ?? [] })));
  }

  getAllManufacturers(businessSearch: BusinessSearch): Observable<ApiResponse<PaginatedApiResponse<Business>>> {
    const params = new HttpParams().append('matchAny', true);

    return this.httpClient.post<ApiResponse<PaginatedApiResponse<Business>>>(`${this.baseUrl}/search`, businessSearch, { params });
  }
}
